












import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class CardWithTitle extends Vue {
  @Prop() readonly title: string;
  @Prop() readonly loading: boolean;
}
